<!-- no profile selected -->
<div class="container container-profile container-profile-company" *ngIf="profile.id == ''">

  <div *ngIf="selectableProfiles.length > 0">

    <div class="page-header">
      <h1 class="page-title">
        {{'Choose profile' | translate}}
      </h1>
    </div>

    <div class="d-flex justify-content-center">
      <a class="btn btn-primary mr-3" [routerLink]="'/company/applications/' + profile.id" *ngFor="let profile of selectableProfiles">
        {{profile.name}}
      </a>
    </div>


  </div>

</div>

<div class="container container-company-applications view view-company-applications" *ngIf="profile.id !== ''">

  <div class="content">

    <div class="row">

      <div class="main col-12">

        <div class="view-filter-toolbar-top">

          <div class="form-inline">

            <div class="input-group mr-3">

              <div class="input-group-prepend">
                <span class="input-group-text">
                  {{'Show' | translate}}
                </span>
              </div>

              <select class="form-control" [(ngModel)]="view.limit" (change)="loadJopPostingApplications()">
                <option *ngFor="let limit of view.limitOptions" [value]="limit.value">
                  {{limit.label}}
                </option>
              </select>

            </div>

            <div class="input-group mr-3">

              <div class="input-group-prepend">
                <div class="input-group-text">{{'Page' | translate}}</div>
              </div>

              <select class="form-control" [(ngModel)]="view.page" (change)="setPage(view.page)">
                <option [value]="key + 1" *ngFor="let page of [].constructor(view.total_pages); let key = index;">
                  {{key + 1}}
                </option>
              </select>

            </div>

          </div>

          <div class="row row-view-results mt-2">
            <div class="col-12">
              {{'Page' | translate}}: {{view.page}} / {{view.total_pages}} |
              {{'Results' | translate}}: {{view.total_results}}
            </div>
          </div>

        </div>

        <app-loader *ngIf="view.isLoading"></app-loader>

        <div class="results" *ngIf="!view.isLoading">

          <div class="results-data" *ngIf="view.data.length > 0">

            <div class="card mb-3" *ngFor="let jobposting of view.data">

              <div class="card-header">
                <h5 class="card-title job-title">
                  {{jobposting.title}}
                </h5>
              </div>

              <div class="card-body jobposting-body-applications">

                <div class="jobposting-applications" *ngIf="jobposting.applications && jobposting.applications.length > 0">

                  <div class="card card-student-application mt-3" *ngFor="let application of jobposting.applications">
                    <div class="card-header">
                      <h5 class="card-title applicant-name">
                        {{application.applicant.firstName}} {{application.applicant.lastName}}
                      </h5>
                    </div>

                    <div class="card-body">

                      <div class="row">

                        <div class="col-12 col-sm-2">
                          <div class="circle overflow-hidden">
                            <img class="img-64 rounded-circle" *ngIf="application.applicant.avatarUri" [src]="application.applicant.avatarUri" />
                          </div>
                        </div>

                        <div class="col-12 col-sm-6">
                          <div class="date" *ngIf="application.createdOn">
                            <fa-icon [icon]="faCalendar"></fa-icon> {{application.createdOn | date:'dd-MM-YYYY'}}
                          </div>
                        </div>

                        <div class="col-12 col-sm-4">

                          <a class="btn btn-outline-primary btn-block" [routerLink]="'/jobposting/' + application.jobPostingId + '/applications/' + application.id ">
                            {{'Open' | translate}}
                          </a>

                          <button class="btn btn-outline-secondary btn-block" (click)="openMotivationModal(application.motivationText)">
                            <fa-icon [icon]="faInfoCircle"></fa-icon> {{'Motivation' | translate}}
                          </button>

                          <a class="btn btn-outline-secondary btn-block" [routerLink]="'/company/students/' + application.applicantId">
                            {{'Profile' | translate}}
                          </a>

                        </div>

                      </div>

                    </div>

                  </div>

                </div>

              </div>

            </div>

            <ngb-pagination (pageChange)="setPage($event)" [(page)]="view.page" [pageSize]="view.limit" [collectionSize]="view.total_results"></ngb-pagination>

          </div>

          <div class="results-none mt-4" *ngIf="view.data.length == 0">
            <div class="alert alert-info">
              {{'No results' | translate}}
            </div>
          </div>

        </div>

      </div>

    </div>

  </div>

</div>
